import { Collapse, Grid } from '@material-ui/core';
import React from 'react';
import { generateLabel } from '../../../../utils/helpers';
import CustomTextField from '../../../CustomTextField';

type Props={
  followUpBossApikey: string;
  isActive: boolean;
  handleChangeClient: ({
    target:
    { name, value, checked },
  }: React.ChangeEvent<HTMLInputElement>) => void;
  validationErrors: any;
};

const FollowUpBossAttributes: React.FC<Props> = props => {
  const {
    followUpBossApikey, isActive, handleChangeClient, validationErrors,
  } = props;

  return (
    <Collapse in={isActive}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('FollowUpBoss_apikey')}
            name="FollowUpBoss Apikey"
            value={followUpBossApikey || ''}
            onChange={handleChangeClient}
            error={Boolean(validationErrors.FollowUpBoss_apikey)}
            helperText={validationErrors.FollowUpBoss_apikey || ''}
          />
        </Grid>
      </Grid>
    </Collapse>

  );
};

export default React.memo(FollowUpBossAttributes);
